// ==============================|| PIN CONFIG (SDÍLENÁ KONSTANTA) ||============================== //
// Jediný zdroj pravdy pro délku PIN kódu (2026-08-27, bezpečnostní zpřísnění
// na výslovné přání uživatele - "kolik zbytečného a zdvojeného kódu tam ještě
// máš" po opakovaném natvrdo zapsaném počtu číslic v PinKeypad.jsx,
// PinRequiredModal.jsx, AuthChangePin.jsx, SignatureCapture.jsx a
// Tenants.jsx). Musí odpovídat PinService::PIN_LENGTH na backendu
// (apps/do-ra.cz/api/src/Modules/Auth/Application/PinService.php) - appka
// nemá žádný mechanismus, jak tuhle hodnotu sdílet mezi PHP a JS automaticky,
// takže při změně backendové konstanty je nutné ručně změnit i tuhle.

export const PIN_LENGTH = 6;

export const PIN_PATTERN = new RegExp(`^\\d{${PIN_LENGTH}}$`);

// Poznámka ke skloňování: český tvar "číslic" (genitiv množného čísla) platí
// pro PIN_LENGTH >= 5 - kdyby PIN_LENGTH kdy kleslo na 2-4, správný tvar by
// byl "číslice". Nepřehnaně řešeno plnou pluralizační funkcí, protože PIN
// kód nikdy nebude kratší než dnešních 6 míst.
export const PIN_MESSAGE = `PIN musí obsahovat přesně ${PIN_LENGTH} číslic.`;
